import React, { useState } from 'react';
import Tool, {
  type IToolAvailableInput,
  type ToolButtonComponent,
} from './Tool';
import ToolButton from '../toolbars/ToolButton';
import { ApplicationView } from '@aha-app/mvc';
import alignedIcon from '../assets/icons/label_conform.svg';
import nonAlignedIcon from '../assets/icons/label_non_conform.svg';
import { svgToIcon } from '../utils/svg';
import { isConnector } from '../objects/guards';

const ToggleAlignmentButton: ToolButtonComponent = ApplicationView(
  ({ selection, tool }) => {
    const [aligned, setAligned] = useState(selection.alignLabels);
    return (
      <span>
        <ToolButton
          onClick={() => {
            if (selection?.toggleLabelAlignment) {
              selection?.toggleLabelAlignment();
              setAligned(!aligned);
            }
          }}
          tool={tool}
        >
          {svgToIcon(aligned ? alignedIcon : nonAlignedIcon)}
        </ToolButton>
      </span>
    );
  }
);

class ToolToggleLabelAlignment extends Tool {
  static toolName = 'Label alignment';

  static available({ selection }: IToolAvailableInput): boolean {
    const objects = selection?.getObjects();
    return (
      objects?.length === 1 &&
      isConnector(objects[0]) &&
      objects[0].labels.length > 0
    );
  }

  static buttonComponent() {
    return ToggleAlignmentButton;
  }
}

export default ToolToggleLabelAlignment;
